<template>
  <div :class="[`questionnaire-question-${display}`, `-${type}-`]">
    <template v-if="option && option.length">
      <UiButton
        v-for="question in option"
        :key="question.id"
        class="-blue-gray- ajax__line"
        :class="[`questionnaire-question-${display}__item`]"
        :style="{minHeight: '39px'}"
      >
        <span style="visibility: hidden">{{ question.title }}</span>
      </UiButton>
    </template>
    <template v-else>
      <UiButton
        class="-blue-gray- ajax__line"
        :class="[`questionnaire-question-grid__item`]"
        :style="{minHeight: '134px'}"
      />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    option: {},
    value: {},
    type: {},
    display: {}
  },
  computed: {
    // minHeight() {
    //   let height = this.type === 'long-text' ? '200px' : '39px'
    //   return height
    // }
  },
  methods: {
    setActive(id) {
      this.$emit('input', id);
    }
  }
};
</script>
